import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/repCurrentCallBoardsStatus/v1/?userUUID=106c67c4-f015-11ee-91f2-b8ca3ad15bed&callType=0&isPagination=0&pageNo=1&perPageRec=3
export const getCurrentCallBoardStatusAPIURL = BaseURl + "userdetails/repCurrentCallBoardsStatus/v1/";



//New callboard status api
export const getNewCurrentCallBoardStatusAPIURL = BaseURl + "userdetails/repCurrentCallBoardsStatus/v2/";
